const fetchReCaptchaToken = async (reCaptchaSiteKey) => {
  const promisifiedGrecaptchaReady = () =>
    new Promise((resolve) => window.grecaptcha.ready(resolve));

  await promisifiedGrecaptchaReady();

  const reCaptchaToken = await window.grecaptcha.execute(
    reCaptchaSiteKey,
    {
      action: 'submit',
    },
  );

  return reCaptchaToken;
};

export default fetchReCaptchaToken;
